const config = require("../config.json");

const sharedConfig = {
  requestorClientId: config.requestorClientId,
  requestorPassword: config.requestorPassword,
  golApiUrl: config.golApiUrl,
  golApiUrlInternal: config.golApiUrlInternal || null,
  fileServerApiUrl: config.fileServerApiUrl,
  fileServerApiUrlInternal: config.fileServerApiUrlInternal || null,
  zaoApiUrl: config.zaoApiUrl,
  cbtApiUrl: config.cbtApiUrl,
  lpcApiUrl: config.lpcApiUrl,
  lpcToken: config.lpcToken,
};

module.exports = sharedConfig;
